/** Usuwa znaczniki dźwiękowe ElevenLabs v3, np. "[laughs] Hello" -> "Hello". */
export function stripTags(s: string): string {
  return s
    .replace(/\[[^\]]*\]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Normalizacja do porównań: małe litery, bez interpunkcji (apostrofy zostają), pojedyncze spacje. */
export function normalize(s: string): string {
  return s
    .toLowerCase()
    .replace(/[’‘`´]/g, "'")
    .replace(/[^a-z0-9'À-ɏąćęłńóśźż\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function tokenize(s: string): string[] {
  const n = normalize(s);
  return n === '' ? [] : n.split(' ');
}

/** Odległość Levenshteina. */
export function levenshtein(a: string, b: string): number {
  if (a === b) return 0;
  if (a.length === 0) return b.length;
  if (b.length === 0) return a.length;
  let prev = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    const cur = [i];
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      cur[j] = Math.min((prev[j] ?? 0) + 1, (cur[j - 1] ?? 0) + 1, (prev[j - 1] ?? 0) + cost);
    }
    prev = cur;
  }
  return prev[b.length] ?? 0;
}

/** Podobieństwo 0..1 (1 = identyczne). */
export function similarity(a: string, b: string): number {
  const max = Math.max(a.length, b.length);
  return max === 0 ? 1 : 1 - levenshtein(a, b) / max;
}

/** Bezpieczna nazwa pliku/identyfikatora dla słowa. */
export function slug(s: string): string {
  return normalize(s).replace(/'/g, '').replace(/\s+/g, '-');
}
